export var testClonabilityOfAudioWorkletNodeOptions = function testClonabilityOfAudioWorkletNodeOptions(audioWorkletNodeOptions) {
  var _MessageChannel = new MessageChannel(),
    port1 = _MessageChannel.port1;
  try {
    // This will throw an error if the audioWorkletNodeOptions are not clonable.
    port1.postMessage(audioWorkletNodeOptions);
  } finally {
    port1.close();
  }
};